import React, { Component } from 'react';
import { Form, Icon, Grid, Label, Message } from 'semantic-ui-react';
import base, { firebase } from '../../rebase';
import { FILETYPE_SCENARIO, FILETYPELABELS, FIREBASEREF_NEWUPLOADS, FIREBASEREF_UPLOADS } from '../../globals';
import * as moment from 'moment';

const MINFILESIZE = 32; //bytes

export default class UploadForm extends Component {
    constructor(props) {
        super(props);

        const localDecimal = localStorage.getItem("decimalseparator");
        const localPeriodExportType = localStorage.getItem("periodexporttype");

        this.state = {
            description: "",
            file: null,
            minus: "",
            plus: "",
            error: "",
            periodexporttype: localPeriodExportType !== null ? localPeriodExportType : "dowgroup",
            decimalseparator: localDecimal !== null ? localDecimal : "."
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    handleFileChange = (e) => {
        const files = e.target.files;
        this.setState({ file: files[0] });
    }

    handleChange(event, target) {
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

        if (name === "periodexporttype" || name === "decimalseparator") {
            localStorage.setItem(name, value);
        }
    }

    onRef = (ref) => {
        this.fileInput = ref;
    }

    resetForm() {
        this.setState({ description: "", loading: false, file: null, minus: "", plus: "" });
        this.fileInput.value = null;
    }

    getUploadData() {
        var data = {
            uid: this.props.authUser.uid,
            user_display_name: this.props.authUser.display_name,
            timestamp: base.timestamp,
            description: this.state.description,
            tour_operator: this.props.authUser.tour_operator,
            status: "new",
            type: this.props.fileType
        };

        if (this.props.fileType === FILETYPE_SCENARIO) {
            var minus = 0;
            if (this.state.minus !== "") minus = this.state.minus;
            data["minus"] = minus;

            var plus = 0;
            if (this.state.plus !== "") plus = this.state.plus;
            data["plus"] = plus;

            data["periodexporttype"] = this.state.periodexporttype;
            data["decimalseparator"] = this.state.decimalseparator;
        }

        return data;
    }

    checkFile() {
        if (this.state.file === null) {
            this.setState({ error: "Please select a (csv) file to upload" });
            return false;
        }

        const extension = this.state.file.name.split('.').pop().toUpperCase();
        if (extension !== "CSV") {
            this.setState({ error: "Please select a CSV file!" });
            return false;
        }

        // if (this.state.file.size < MINFILESIZE) {
        //     this.setState({ error: "Looks like your CSV file is empty or too small!" });
        //     return false;
        // }

        return true;
    }

    handleSubmit(e) {
        if (!this.checkFile()) return;
        if (!this.canUpload()) return;

        this.setState({ loading: true, error: "" });

        // First upload file, then metadata
        const uploadref = firebase.database().ref(FIREBASEREF_UPLOADS).push();
        const key = uploadref.key;
        const storageref = FIREBASEREF_UPLOADS + "/" + this.props.authUser.tour_operator + '/' + this.props.authUser.uid + '/' + key;

        firebase.storage().ref(storageref).put(this.state.file).then(function (snapshot, error) {
            if (error) {
                console.log(error);
                this.setState({ error: "Unknown error occurred" });
                return;
            }

            base.update(FIREBASEREF_UPLOADS + "/" + key, {
                data: this.getUploadData(),
                then: function (error) {
                    if (!error) {
                        // success
                        base.update(FIREBASEREF_NEWUPLOADS, {
                          data: { [key]: true }
                        });
                        this.resetForm();
                    } else {
                        console.log(error);
                        this.setState({ error: "Unknown error occurred" });
                    }
                }.bind(this)
            });
        }.bind(this));

        e.preventDefault();
    }

    isInWindow(window) {
        const now = moment();
        let from = moment(window.from, "DD-MM-YYYY kk:mm:ss");
        let to = moment(window.to, "DD-MM-YYYY kk:mm:ss");

        let inwindow = true;
        if (now.isBefore(from)) inwindow = false;
        if (now.isAfter(to)) inwindow = false;

        return inwindow;
    }

    canUpload() {
        let windows = null;
        if (this.props.fileType === FILETYPE_SCENARIO) {
            windows = this.props.authUser.topData.upload_windows;
        } else {
            windows = [this.props.authUser.topData.basiswens_window];
        }
        if (!windows) return false;

        for (let i = 0; i < windows.length; i++) {
            if (!this.isInWindow(windows[i])) continue;
            return true;
        }

        return false;
    }

    getScenarioFormControls = () => (
        <Grid>
            <Grid.Column width={5}>
                <Form.Group>
                    <Form.Input
                        width={8}
                        name="minus"
                        label="Minus"
                        placeholder="0"
                        value={this.state.minus}
                        onChange={this.handleChange}
                        type="number"
                        max="0"
                    />
                    <Form.Input
                        width={8}
                        name="plus"
                        label="Plus"
                        placeholder="0"
                        value={this.state.plus}
                        onChange={this.handleChange}
                        type="number"
                        min="0"
                    />
                </Form.Group>
            </Grid.Column>
            <Grid.Column width={6}>
                <Form.Field>
                    <label>Period export type</label>
                </Form.Field>
                <Form.Group inline>
                    <Form.Radio
                        label='Week / weekend'
                        name='periodexporttype'
                        value='dowgroup'
                        checked={this.state.periodexporttype === 'dowgroup'}
                        onChange={this.handleChange}
                    />
                    <Form.Radio
                        label='Day of week'
                        name='periodexporttype'
                        value='dow'
                        checked={this.state.periodexporttype === 'dow'}
                        onChange={this.handleChange}
                    />
                </Form.Group>
            </Grid.Column>
            <Grid.Column width={5}>
                <Form.Field>
                    <label>Decimal separator</label>
                </Form.Field>
                <Form.Group inline>
                    <Form.Radio
                        label='Dot (.)'
                        name='decimalseparator'
                        value='.'
                        checked={this.state.decimalseparator === '.'}
                        onChange={this.handleChange}
                    />
                    <Form.Radio
                        label='Comma (,)'
                        name='decimalseparator'
                        value=','
                        checked={this.state.decimalseparator === ','}
                        onChange={this.handleChange}
                    />
                </Form.Group>
            </Grid.Column>
        </Grid>
    )

    render() {
        if (!this.canUpload()) {
            return <Message warning content={`Currently, you can not upload ${FILETYPELABELS[this.props.fileType]} files.`} />
        }

        const isScenario = this.props.fileType === FILETYPE_SCENARIO;

        let label = (
            <Label size="large" pointing="left">
                {this.state.file ? this.state.file.name : "No file selected"}
            </Label>
        )

        return (
            <Form error={this.state.error !== ""} loading={this.state.loading} onSubmit={this.handleSubmit}>
                <Message error content={this.state.error} />
                <Form.Input
                    name="description"
                    label="Description"
                    placeholder="Description"
                    value={this.state.description}
                    onChange={this.handleChange} />
                {isScenario && this.getScenarioFormControls()}
                <Form.Group inline>
                    <div style={{ paddingTop: 8 }}>
                        <label htmlFor="upload_file_input" className="ui green compact medium button">
                            <Icon name="file outline" />
                            Select file
                        </label>
                        <input type="file" id="upload_file_input" style={{ display: "none" }} onChange={(evt) => this.handleFileChange(evt)} ref={this.onRef} />
                        {label}
                    </div>
                </Form.Group>
                <Grid textAlign="right">
                    <Grid.Column>
                        <Form.Button color="green" type='submit'>
                            <Icon name="upload" />
                            Upload file
                        </Form.Button>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home/UploadForm.js